export enum IHubPackageVisibility {
  Private = "Private",
  Company = "Company",
  Platform = "Platform",
  /* Global = "Global", */
}
